import { useWidgetData } from '../useWidgetData'

import { StatisticValueMetadata } from '../../../types/court/court'
import { ReportInterval } from '../../../types/report/report'
import { createReportQuery } from '../../../utils/reportUtils'

export const useAveragePriceWidget = (interval: ReportInterval) =>
  useWidgetData<StatisticValueMetadata>(
    `average-price?${createReportQuery(interval)}`
  )
